module.exports = __webpack_public_path__ + "img/faq_ladies_on_click.c4e36b7e.jpg";